<script lang="ts">
    import { GiftStore, PricingPlan } from "$/stores/GiftStore";
    import { TokenStore } from "$/stores/TokenStore";
    import { clickAction } from "$/utils/clickAction";

    export let loading = false;
    export let pricingPlan: PricingPlan = PricingPlan.FREE;

    let activeUser = $TokenStore?.user;
    let username = "";
    let message = null;

    // validate email allow + - _ .
    $: notValidEmail = !username.match(
        /^[a-zA-Z0-9._\+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,12}$/,
    );
    $: showOwnerError = username === activeUser?.username;
    $: showWarning = showOwnerError || username !== "" || message;
    $: submitNotAllowed = notValidEmail || showOwnerError;

    async function sendGift() {
        if (submitNotAllowed) return;

        let gift = {
            pricingPlan: pricingPlan,
            recipient: {
                username: username,
            },
        };

        try {
            loading = true;
            await GiftStore.sendGift(gift);
            username = "";
        } catch (error) {
            let errorResponse = await error?.error?.json();
            message = errorResponse.error ?? "Something went wrong";
        } finally {
            loading = false;
        }
    }

    function handleKeyDown(event) {
        if (event.key === "Enter" && !submitNotAllowed) sendGift();

        message = null;
    }
</script>

{#if loading}
    <div class="send-gift">
        <div class="main-content">
            <input class="email-input" placeholder="Validating...." disabled />
        </div>
    </div>
{:else}
    <div class="send-gift">
        <div class="main-content" class:main-content--warning={showWarning}>
            <input
                class="email-input"
                placeholder="Email address"
                name="email"
                type="email"
                bind:value={username}
                on:keydown={handleKeyDown}
            />

            {#if !submitNotAllowed}
                <div class="invite-user-button" use:clickAction={sendGift}>
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke-width="1.5"
                        stroke="currentColor"
                    >
                        <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75"
                        />
                    </svg>
                </div>
            {/if}
        </div>

        <span class="email-message">
            {#if username !== ""}
                {#if message !== null}
                    {message}
                {:else if notValidEmail}
                    Not a valid email address
                {:else if showOwnerError}
                    You can't invite yourself silly 🙃
                {:else}
                    Click the envelope above to <b>invite them over email</b>.
                {/if}
            {/if}
        </span>
    </div>
{/if}

<style>
    @import "../../../../main.css";

    .send-gift {
        @apply flex flex-col gap-1 !important;
    }

    .email-input {
        @apply reset w-full bg-transparent text-sm !important;
    }

    .email-message {
        @apply mx-6 text-xs text-pink-500 !important;
    }

    .email-message b {
        @apply reset text-xs font-bold text-pink-500 !important;
    }

    .main-content {
        @apply flex flex-row items-center gap-1 rounded-full border border-gray-200 bg-white p-4 !important;
    }

    .main-content--warning {
        @apply border-pink-500 !important;
    }

    .invite-user-button {
        @apply cursor-pointer !important;
    }
    .invite-user-button svg {
        @apply h-5 w-5 !important;
    }
</style>
